export default "__VITE_PUBLIC_ASSET__1403ede4__"